import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';
import { normalizeImgSrc } from '../utils';

import {
  extractBlocks,
  extractBlocksForSatelliteGrid,
  extractHeadingHtml,
  extractDescriptionHtml,
  extractSurveyHtml,
  extractSurveyItems,
  extractSpecTableHtml,
  resolveMediaPosition,
  extractBlocksCol_1,
} from '../helpers/extract-suggestion';

export const buildCardSmokingSection = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const { blockMedia, blockContent } = extractBlocks(suggestionFields);
  const imgFallback = 'https://cdn.skyfastimg.com/images/2026/07/20/image-6a5ddda9d221c26bbb0d389a.png';
  const mediaType = blockMedia?.media.media_type;

  const fieldUpdate = {
    title: 'Image with Text 2',
    enableAnchor: false,
    'card-content': '#000000',
    'card-item-content': 1,
    'card-item-image': 2,
    'card-image': mediaType !== 'video' ? normalizeImgSrc(blockMedia?.media.url || imgFallback) : imgFallback,
    'card-title': extractHeadingHtml(blockContent) + '<p></p>',
    'card-description':
      extractDescriptionHtml(blockContent) + extractSpecTableHtml(blockContent) + extractSurveyHtml(blockContent),
    'text-color': '#ffffff',
    topPadding: true,
    bottomPadding: true,
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionCardSmoking(newSection.html, fieldUpdate),
  };
};

export const buildCustomizeCardSection = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const { blockMedia, blockContent } = extractBlocks(suggestionFields);
  const { contentOrder, imageOrder } = resolveMediaPosition(suggestionFields);

  const buttonCta = blockContent.find(b => b.block_type === 'cta');
  const hasRating = blockContent.find(b => b.block_type === 'rating_badge');
  const imgFallback = 'https://cdn.skyfastimg.com/images/2026/07/20/image-6a5ddda9d221c26bbb0d389a.png';
  const mediaType = blockMedia?.media.media_type;

  const fieldUpdate = {
    title: 'Side by Side',
    enableAnchor: false,
    'card-container': '#ffffff',
    'card-item-content': contentOrder,
    'card-item-image': imageOrder,
    'card-btn-row': !!buttonCta,
    'card-rated-row': !!hasRating,
    'card-btn': {
      text: buttonCta?.cta_items?.[0]?.label || '',
      url: '#',
      background: '#2d3436',
      color: '#ffffff',
    },
    'card-image': mediaType !== 'video' ? normalizeImgSrc(blockMedia?.media.url || imgFallback) : imgFallback,
    'sub-btn': '',
    'rating-stars': 5,
    'rating-text': '',
    'card-title': extractHeadingHtml(blockContent),
    'card-description':
      extractDescriptionHtml(blockContent) + extractSpecTableHtml(blockContent) + extractSurveyHtml(blockContent),
    'card-survay': false,
    'items-survay': [],
    'container-page': { 'show-style': false, background: '#fff' },
    'style-center-y': true,
    'text-color': '#000',
    topPadding: true,
    bottomPadding: true,
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionCustomizeCard(newSection.html, fieldUpdate),
  };
};

//has spec
export const buildCardBasicRivoneedSection = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const { blockMedia, blockContent } = extractBlocks(suggestionFields);
  const { positionMedia } = resolveMediaPosition(suggestionFields);
  const mediaType = blockMedia?.media.media_type;

  const spectItems = blockContent.find(b => b.block_type === 'spec_table')?.spec_table_items || [];
  const spectItemFallback = [
    {
      label: 'Weight',
      value: '100g',
    },
    {
      label: 'Dimension',
      value: '10x10x10 cm',
    },
    {
      label: 'Resolution',
      value: '1080x1920',
    },
    {
      label: 'Resolution',
      value: '1080x1920',
    },
    {
      label: 'Resolution',
      value: '1080x1920',
    },
  ];

  const imgFallback = 'https://cdn.skyfastimg.com/images/2026/07/20/image-6a5ddda9d221c26bbb0d389a.png';

  const fieldUpdate = {
    title: 'Side by Side',
    enableAnchor: false,
    'card-container': '#ffffff',
    'container-page': { 'show-style': false, background: '#fff' },
    'style-center-y': true,
    'text-color': '#000',
    topPadding: true,
    bottomPadding: true,
    leftCard: {
      order: positionMedia === 2 ? 1 : 2,
      colorBorder: '#bababa',
    },
    rightCard: {
      order: positionMedia === 2 ? 2 : 1,
      image: mediaType !== 'video' ? normalizeImgSrc(blockMedia?.media.url || imgFallback) : imgFallback,
    },
    titleContent:
      extractHeadingHtml(blockContent) +
      ' ' +
      extractDescriptionHtml(blockContent) +
      ' ' +
      extractSurveyHtml(blockContent),
    items: spectItems,
    settings: {
      paddingTop: true,
      paddingBottom: true,
      backgroundColor: '#FFFFFF',
      textColor: '#000000',
      overlayColor: '#000000',
      overlayOpacity: 0,
      showOverlay: false,
      backgroundImage: '',
      useBackgroundMobile: false,
      backgroundImageMobile: '',
    },
  };

  if (!spectItems.length) {
    fieldUpdate.items = spectItemFallback;
  }

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionCardBasicRivoneed(newSection.html, fieldUpdate),
  };
};

//stat
export const buildCardWithSurveySection = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const { blockMedia, blockContent } = extractBlocks(suggestionFields);
  const { contentOrder, imageOrder } = resolveMediaPosition(suggestionFields);

  const buttonCta = blockContent.find(item => item.block_type === 'cta')?.cta_items?.[0];

  const itemsSurvey = extractSurveyItems(blockContent);

  const itemsSurveyFallback = [
    {
      description: 'Recommended',
      percent: 50,
    },
    {
      description: 'Not Recommended',
      percent: 50,
    },
  ];
  const imgFallback = 'https://cdn.skyfastimg.com/images/2026/07/20/image-6a5ddda9d221c26bbb0d389a.png';
  const mediaType = blockMedia?.media.media_type;
  const fieldUpdate = {
    title: 'Side by Side',
    enableAnchor: false,
    'card-item-content': contentOrder,
    'card-item-image': imageOrder,
    'card-btn-row': !!buttonCta,
    'card-btn': { text: buttonCta?.label, url: '#' },
    'card-image': mediaType !== 'video' ? normalizeImgSrc(blockMedia?.media.url || imgFallback) : imgFallback,
    'sub-btn': buttonCta?.sub_text,
    'card-title': extractHeadingHtml(blockContent),
    'card-description': extractDescriptionHtml(blockContent),
    'card-survay': true,
    'items-survay': itemsSurvey,
    'style-center-y': true,
  };

  if (!itemsSurvey.length) {
    fieldUpdate['items-survay'] = itemsSurveyFallback;
  }
  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionCardWithSurvey(newSection.html, fieldUpdate),
  };
};

//table
export const buildCardWithTableCompare = (baseTemplate, suggestionFields, suggestionTags) => {
  const isTable = suggestionTags.includes('comparison_table');
  if (!isTable) return null;
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));

  if (!newSection?.html) return null;

  const { blockContent } = extractBlocks(suggestionFields);
  const heading = extractHeadingHtml(blockContent);
  const comparison_table = blockContent.find(item => item.block_type === 'comparison_table');
  const firstTitle = comparison_table?.comparison_table_data?.competitor_columns?.[0];
  const secondTitle = comparison_table?.comparison_table_data?.competitor_columns?.[1];

  const listItem =
    comparison_table?.comparison_table_data?.rows?.map(i => {
      return {
        comparisonContent: i.label,
        firstTd: i.values?.[0] === 'check',
        secondTd: i.values?.[1] === 'check',
      };
    }) || [];
  const listItemFallback = [
    {
      comparisonContent: 'Weight',
      firstTd: true,
      secondTd: false,
    },
    {
      comparisonContent: 'Dimension',
      firstTd: true,
      secondTd: false,
    },
    {
      comparisonContent: 'Resolution',
      firstTd: true,
      secondTd: false,
    },
  ];
  const fieldUpdate = {
    enableAnchor: true,
    title: 'Table Compare',
    'card-title': heading,
    'first-title': firstTitle || 'Luxova Draw Buddys',
    'second-title': secondTitle || 'Other Toys',
    'table-body': {
      background: '#17d4f4',
      color: '#000000',
    },
    listItem: listItem,
  };

  if (!listItem.length) {
    fieldUpdate.listItem = listItemFallback;
  }

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionCardWithTableCompare(newSection.html, fieldUpdate),
  };
};

//video
export const buildCardVideoSection = (baseTemplate, suggestionFields, suggestionTags) => {
  const isVideo = suggestionTags.includes('media_video');
  if (!isVideo) return null;
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));

  if (!newSection?.html) return null;

  const headingFallback = `
  <h2>Lorem ipsum dolor sit amet</h2>
  <p>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
    tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
  </p>
  `;

  const { blockMedia, blockContent } = extractBlocks(suggestionFields);
  const heading = extractHeadingHtml(blockContent) || headingFallback;
  const videoUrl =
    blockMedia?.media.media_type === 'video'
      ? normalizeImgSrc(blockMedia?.media.url)
      : 'https://hizoo.co/cdn/shop/videos/c/vp/8146864885be45f2b9fb51b405461635/8146864885be45f2b9fb51b405461635.HD-1080p-7.2Mbps-48092137.mp4?v=0';

  const fieldUpdate = {
    enableAnchor: true,
    title: 'Video With Text',
    'card-video': videoUrl,
    'card-title': heading,
    'card-description': extractDescriptionHtml(blockContent),
    'wrap-img-radius': 20,
    'style-center-y': true,
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionCardVideo(newSection.html, fieldUpdate),
  };
};

//Satellite Grid Section
export const buildSatelliteGridSection = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));

  if (!newSection?.html) return null;

  const { blockMedia, blockHeading, blockListItem } = extractBlocksForSatelliteGrid(suggestionFields);

  const headingHtml = `${blockHeading?.heading?.text ? `<h2>${blockHeading?.heading?.text}</h2>` : ''} ${
    blockHeading?.body_text?.text ? `<p>${blockHeading?.body_text?.text}</p>` : ''
  }`;

  const listItem =
    blockListItem?.map(item => {
      return {
        title: item.title,
        description: item.description || item.subtitle || '',
        image: normalizeImgSrc(item.image_url),
      };
    }) || [];

  const fieldUpdate = {
    enableAnchor: false,
    title: 'Satellite Grid Section',
    'main-title-satellite': headingHtml,
    'main-image-satellite': normalizeImgSrc(blockMedia?.media.url || ''),
    'items-satellite': listItem,
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionSatelliteGrid(newSection.html, fieldUpdate),
  };
};

//Image With Text Col1 Section
export const buildImageWithTextCol1Section = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));

  if (!newSection?.html) return null;

  const { blockMedia, blockText } = extractBlocksCol_1(suggestionFields);

  const headingText =
    blockText
      .map(i => {
        return i.block_type === 'heading'
          ? `<h2 style="text-align: center;">${i.text}</h2>`
          : `<p style="text-align: center;">${i.text}</p>`;
      })
      .join('') || '';

  const fieldUpdate = {
    cardTitle: {
      show: !!headingText,
      content: headingText,
    },
    cardImage: {
      show: !!blockMedia,
      src: normalizeImgSrc(blockMedia?.media.url || ''),
    },
    button: {
      show: false,
      text: '',
      link: '#',
    },
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionImageWithTextCol1(newSection.html, fieldUpdate),
  };
};

//Have icon grid
export const buildFaqCardSection = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));

  if (!newSection?.html) return null;

  const blockAll = (suggestionFields?.columns || [])?.reduce((acc, column) => {
    return [...acc, ...column.blocks];
  }, []);

  const blockMedia = blockAll.find(b => b.block_type === 'media') ?? null;
  const blockTextHtml = blockAll
    .filter(b => b.block_type === 'heading' || b.block_type === 'body_text')
    .map(i => {
      return i.block_type === 'heading'
        ? `<h2 style="text-align: center;">${i.text}</h2>`
        : `<p style="text-align: center;">${i.text}</p>`;
    })
    .join('');

  const blockIconGrids = blockAll.filter(b => b.block_type === 'icon_grid') || [];
  const blockIconGrid = blockIconGrids.flatMap(i => i.icon_grid_items || []);
  const headingContent = suggestionFields.content?.heading || '';

  const headingHtml = `<h2 style="text-align: center;">${headingContent}</h2> ${blockTextHtml}`;
  const listItem = blockIconGrid.map(i => {
    return {
      question: i.title || '',
      answer: i.subtitle || '',
      image: normalizeImgSrc(
        i.icon_url || 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dbb563c26afe82182b3b.webp?w=50',
      ),
    };
  });

  const fieldUpdate = {
    titleFaq: headingHtml,
    cardImage: normalizeImgSrc(blockMedia?.media.url || ''),
    listItem,
    cardContent: '',
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionFaqCard(newSection.html, fieldUpdate),
  };
};
